import { PageHeader, type PageHeaderProps } from '@components/page-header/page-header';
import { RichIcon, type RichIconTypes } from '@eika/rich-icon';
import './page-header-with-rich-icon.scss';

interface PageHeaderWithRichIconProps extends PageHeaderProps {
    richIconType: RichIconTypes;
    iconOnTopInMobile?: boolean;
    centerInMobile?: boolean;
}

export const PageHeaderWithRichIcon = ({
    header,
    ingress,
    richIconType,
    iconOnTopInMobile = false,
    centerInMobile = false,
}: PageHeaderWithRichIconProps) => {
    return (
        <div
            className={`page-header-with-rich-icon ${iconOnTopInMobile ? 'page-header-with-rich-icon--reversed' : ''}  ${centerInMobile ? 'page-header-with-rich-icon--centered' : ''}`}
        >
            <PageHeader header={header} ingress={ingress} />
            <RichIcon className="page-header-with-rich-icon__rich-icon" type={richIconType} maxHeight={190} />
        </div>
    );
};
